import type { UserData } from '@/types';

export class User {
  private readonly _id: string;
  private readonly _name?: string;
  private readonly _email?: string;
  private readonly _title?: string;
  private readonly _description?: string;
  private readonly _emoji?: string;
  private readonly _avatarUrl?: string;
  private readonly _createdAt: string;
  private readonly _updatedAt: string;

  constructor(data: UserData) {
    this._id = data.id.toString();
    this._name = data.name;
    this._email = data.email;
    this._title = data.title;
    this._description = data.description;
    this._emoji = data.emoji;
    this._avatarUrl = data.avatar_url;
    this._createdAt = data.created_at;
    this._updatedAt = data.updated_at;
  }

  // Factory method to create from API data
  static fromApi(data: UserData): User {
    return new User({
      ...data,
    });
  }

  // Getters for all properties
  get id(): string { return this._id; }
  get name(): string { return this._name || ''; }
  get email(): string { return this._email || ''; }
  get title(): string { return this._title || ''; }
  get description(): string { return this._description || ''; }
  get emoji(): string { return this._emoji || ''; }
  get avatarUrl(): string { return this._avatarUrl || ''; }
  get createdAt(): string { return this._createdAt; }
  get updatedAt(): string { return this._updatedAt; }

  url(): string {
    return `/user/${this.id}`;
  }
}
